/**
 * insurancePolicy — règles de couverture d'assurance par tier de véhicule.
 *
 * 13/06/2026 (retour utilisateur) : « Il faut rendre l'assurance des
 * camions tiers 5 en assurance premium. Tiers 3/4 [standard]. »
 *
 *   T1-T2 : libre (basic / standard / premium)
 *   T3-T4 : minimum standard (les assureurs refusent le basic sur les
 *           porteurs lourds)
 *   T5    : premium OBLIGATOIRE (valeur des actifs + exigences des
 *           chargeurs grands comptes)
 */
export const COVERAGE_RANK = { basic: 1, standard: 2, premium: 3 };

export function minCoverageForTier(vehicleTier) {
  const t = vehicleTier || 1;
  if (t >= 5) return 'premium';
  if (t >= 3) return 'standard';
  return 'basic';
}

export function defaultCoverageForTier(vehicleTier) {
  return (vehicleTier || 1) >= 5 ? 'premium' : 'standard';
}

export function isCoverageAllowed(vehicleTier, coverage) {
  return (COVERAGE_RANK[coverage] || 0) >= (COVERAGE_RANK[minCoverageForTier(vehicleTier)] || 1);
}

/* Taux de remboursement par type de sinistre catastrophique. */
export const CATA_REPAIR_COVERAGE = { basic: 0.60, standard: 0.80, premium: 0.95 };
export const CATA_THEFT_COVERAGE = { basic: 0.40, standard: 0.70, premium: 0.90 };
export const CATA_CARGO_COVERAGE = { basic: 0, standard: 0.40, premium: 0.70 };
